import { useForm, SubmitHandler, FieldValues, DefaultValues } from "react-hook-form";

interface UseCustomFormProps<T extends FieldValues> {
  defaultValues: DefaultValues<T>;
  onSubmit: SubmitHandler<T>;
}

export function useCustomForm<T extends FieldValues>({
  defaultValues,
  onSubmit,
}: UseCustomFormProps<T>) {
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    reset,
    watch
  } = useForm<T>({
    mode: "onChange",
    defaultValues,
  });

  const submitHandler = handleSubmit(onSubmit);

  return { register, errors, isValid, submitHandler, reset, watch };
}
